var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "*",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#133F26",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.415.5c.316 0 .572.256.572.571v14.286h14.285a.571.571 0 0 1 0 1.143H1.415a.571.571 0 0 1-.571-.571V1.07C.844.756 1.1.5 1.415.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17 3.367a.572.572 0 0 1 .434.097l4 2.857a.571.571 0 0 1-.664.93l-3.52-2.514-4.244 6.366a.572.572 0 0 1-.88.087L4.44 8.333a.571.571 0 1 1 .808-.808l2.364 2.364 4.185-6.277a.571.571 0 0 1 .372-.245Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.844.5h16v16h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.15f66bb4e15c8167a9934693a55f8983.svg";
export { ForwardRef as ReactComponent };